import logo from './logo.svg';
import './App.css';
import HomePage from './pages/home/HomePage';
import { ParallaxProvider } from 'react-scroll-parallax';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProjectsListPage from './pages/projects/ProjectsListPage';
import ProjectDetailsPage from './pages/projects/ProjectDetailsPage';
function App() {
  return (
   
    <div className="App">

       <ParallaxProvider>
       <BrowserRouter>
             <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/projects" element={<ProjectsListPage />} />
                  <Route path="/project/:id" element={<ProjectDetailsPage />} />
              </Routes>
         </BrowserRouter>
        </ParallaxProvider>
      
    </div>
  );
}

export default App;
